import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getWMSSHIPPINGTableStructure";
export const UPDATE_TABLE_DATA = "getWMSSHIPPINGTableData";
export const UPDATE_CONFIRM_ORDER_DATA = "getWMSSHIPPINGConfirmOrderData";

// mutation types
export const SET_TABLE_STRUCTURE = "setWMSSHIPPINGTableStructure";
export const SET_TABLE_DATA = "setWMSSHIPPINGTableData";
export const SET_TABLE_FILTER = "setWMSSHIPPINGTableFilter";
export const SET_TABLE_PAGE = "setWMSSHIPPINGTablePage";
export const SET_TABLE_PERPAGE = "setWMSSHIPPINGTablePerPage";
export const SET_TABLE_SORTBY = "setWMSSHIPPINGTableSortBy";
export const SET_CONFIRM_ORDER_DATA = "setWMSSHIPPINGUpdateOrderData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  confirm_order: {},
};

const getters = {
  /**
   * for table title, descripton
   * */
  getWMSSHIPPINGTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getWMSSHIPPINGTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getWMSSHIPPINGTableState(state) {
    return state.table_state;
  },
  getWMSSHIPPINGTableHeaders(state) {
    return state.table_structure.columns;
  },
  getWMSSHIPPINGTableFilters(state) {
    return state.table_structure.filters;
  },
  getWMSSHIPPINGTableData(state) {
    return state.table_data.data;
  },
  getWMSSHIPPINGExportUrl(state) {
    return state.export_link;
  },
  getWMSSHIPPINGConfirmOrderData(state) {
    return state.confirm_order;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/shipping")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/shipping/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_CONFIRM_ORDER_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/shipping/show", payload)
        .then(({ data }) => {
          context.commit(SET_CONFIRM_ORDER_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  // [SET_TABLE_SORTORDER](state, sortOrder) {
  //   state.table_state.sortOrder = sortOrder;
  // },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_CONFIRM_ORDER_DATA](state, order_data) {
    state.confirm_order = order_data;
  },
  // [SET_EXPORT_LINK](state, link) {
  //   state.export_link = link;
  // },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
